/* @flow */

import type { KeyValuePair } from '../../../../helpers/jsHelpers/types';

export type NETGEM_API_PLAYINGHISTORY_PROFILE = { date: string };

export type NETGEM_API_PLAYINGHISTORY_ITEM = {
  channelId: string,
  locationId: string,
  profiles: KeyValuePair<NETGEM_API_PLAYINGHISTORY_PROFILE>,
};

export type NETGEM_API_PLAYINGHISTORY_ITEM_EXTENDED = {
  ...NETGEM_API_PLAYINGHISTORY_ITEM,
  programId: string,
};

// Keys are game Ids (starting with "program://")
export type NETGEM_API_PLAYINGHISTORY = KeyValuePair<NETGEM_API_PLAYINGHISTORY_ITEM>;

export type PLAYING_HISTORY_ARRAY_TYPE = Array<NETGEM_API_PLAYINGHISTORY_ITEM_EXTENDED>;

const playingHistoryArrayToObject = (playingHistoryArr: PLAYING_HISTORY_ARRAY_TYPE): NETGEM_API_PLAYINGHISTORY => {
  const playingHistoryObj: NETGEM_API_PLAYINGHISTORY = {};

  playingHistoryArr.forEach(({ channelId, locationId, profiles, programId }) => {
    playingHistoryObj[programId] = { channelId, locationId, profiles };
  });

  return playingHistoryObj;
};

const playingHistoryObjectToArray = (playingHistoryObj: NETGEM_API_PLAYINGHISTORY): PLAYING_HISTORY_ARRAY_TYPE =>
  Object.entries(playingHistoryObj).map(([programId, value]) => {
    const { channelId, locationId, profiles } = value;
    return { channelId, locationId, profiles, programId };
  });

export { playingHistoryArrayToObject, playingHistoryObjectToArray };
